import { color } from "highcharts";
import { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../assets/css/datepicker.css";
import moment from "moment";
class DateRangePickerV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.startDate ? moment(props.startDate).toDate() : new Date("2014/02/08"),
      endDate: props.endDate ? moment(props.endDate).toDate() : new Date("2014/02/10"),
    };
  }
  componentDidMount() {
    let { startDate, endDate } = this.props;
    this.setState({
      startDate: startDate ? moment(startDate).toDate() : new Date("2014/02/08"),
      endDate: endDate ? moment(endDate).toDate() : new Date("2014/02/10"),
    });
  }
  handleStartDateChange = (date) => {
    this.setState({ startDate: date });
    if (this.props.onDateChange) {
      this.props.onDateChange({ startDate: date, endDate: this.state.endDate });
    }
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date });
    if (this.props.onDateChange) {
      this.props.onDateChange({ startDate: this.state.startDate, endDate: date });
    }
  };
  render() {
    return (
      <div
        className="range-date-wrapper d-flex text-white"
        style={{
          color: "white",
        }}
      >
        <DatePicker
          selected={this.state.startDate}
          onChange={this.handleStartDateChange}
          selectsStart
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          dateFormat="dd/MM/yyyy"
        />
        -
        <DatePicker
          selected={this.state.endDate}
          onChange={this.handleEndDateChange}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          minDate={this.state.startDate}
          dateFormat="dd/MM/yyyy"
        />
        <div
          className=""
          style={{
            color: "#3dc99f",
            fontSize: "16px",
          }}
        >
          <i className="fas fa-calendar-days"></i>
        </div>
      </div>
    );
  }
}
export default DateRangePickerV2;
